<template>
  <div class="studio-wrapper">
    <div class="studio" v-if="dataDone">
      <!-- 课程基本信息 -->
      <div class="studio-baseinfo">
        <div class="title">{{studioData.title}}<span class="status-label"></span></div>
        <div class="studio-number" v-if="studioData.studio_num && studioData.studio_num != 0"><icon icon-class="studio-icon"></icon>这是第<span class="number">{{studioData.studio_num}}</span>个凯诺设计室</div>
        <!-- 特殊设计室不显示此模块 -->
        <div class="info-block" v-if="!isSpecialStudio">
          <div class="info-item" v-if="studioData.status == 1">
            <span class="type">开课时间</span>
            <div class="content">{{studioData.localStartTime}}</div>
          </div>
          <div class="info-item" v-else-if="studioData.status == 2">
            <span class="type">开课时间</span>
            <div class="content">课程正在进行中</div>
          </div>
          <div class="info-item" v-else-if="studioData.status == 3">
            <span class="type">开课时间</span>
            <div class="content">课程已结束</div>
          </div>
          <div class="info-item" v-if="studioData.status == 1 && !isStop">
            <span class="type">报名截止时间</span>
            <div class="content error">{{studioData.courseStopApplyTime}}</div>
          </div>
        </div>
      </div>
      <!-- 课程封面 -->
      <div class="studio-cover" :class="{'status-bar': (studioData.status == 1 && !isStop)}">
        <div class="studio-video-title" v-if="studioData.video">开题视频<img src="/Application/Home/Resource/static/images/mobile/video-arrow.png"></div>
        <div class="studio-video-box">
          <img :src="studioData.thumb" v-if="studioData.video == 0">
          <video-player :src="studioData.video_url" :poster="studioData.thumb" v-else></video-player>
        </div>
        <div class="cover-info" :class="{'soon': (studioData.status == 1 && studioData.stopSoon)}" v-if="studioData.status == 1 && !isStop">
          <div class="cover-tips">
            <icon icon-class="new-clock"></icon>
            报名截止时间: {{studioData.courseStopApplyTime}}
          </div>
        </div>
      </div>
      <!-- 课程主要内容 -->
      <div class="course-main-wrapper">
        <div class="tab-wrapper" ref="courseTab">
          <div class="course-tab" :class="{'fixed': tabFixed}">
            <div class="tab-item" :class="{'active': activeTab == 'info'}" @click="tab('info')">课程信息</div>
            <div class="tab-item" :class="{'active': activeTab == 'sign'}" @click="tab('sign')">报名须知</div>
            <div class="tab-item" :class="{'active': activeTab == 'other'}" @click="tab('other')">相关课程</div>
          </div>
        </div>
        <!-- 课程内容 -->
        <div class="course-info-main">
          <div class="course-block">
            <div class="sub-info">适用专业：{{studioData.major}}</div>
            <div class="sub-info">{{!isSpecialStudio ? '节次' : '课时'}}：{{studioData.course_num}}<span v-if="!isSpecialStudio">节</span><span v-else>课时</span>（{{studioData.knb}}凯诺币）</div>
            <div class="sub-info">难度：{{studioData.course_level}}</div>
          </div>
          <div class="course-block" v-if="studioDetail.preface">
            <div class="info-content preface">
              <div class="rich-text" v-html="studioDetail.preface"></div>
            </div>
          </div>
          <!-- 特殊设计室不显示此模块 -->
          <div class="course-block" v-if="!isSpecialStudio">
            <div class="info-title">指导老师</div>
            <div class="info-content">
              <div class="course-teacher" :style="{cursor: item.is_trained == 1 ? 'pointer' : 'default'}" v-for="item in studioData.teacher_info" :key="item.id" @click="checkTeacher(item)">
                <div class="teacher-avatar"><img :src="item.avatar"></div>
                <div class="teacher-info">
                  <div class="teacher-name">{{item.teacher_name}}</div>
                  <div class="teacher-title-box">
                    <div class="teacher-title">{{item.title1}}</div>
                    <div class="teacher-title">{{item.title2}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="studio-link" v-if="studioDetail.article_info" @click="toStudioAwards(studioDetail.article_info.id)">
              <div class="link-text">
                <div class="link-title">往期设计室优秀作品</div>
                <div class="check-link">立即查看 <icon icon-class="arrow-right"></icon></div>
              </div>
              <div class="awards-icon"><img class="awards" src="/Application/Home/Resource/mini-program-static/awards.png"></div>
            </div>
          </div>
          <div class="course-block" v-if="studioDetail.goal">
            <div class="info-title">课程目标</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.goal"></div>
            </div>
          </div>
          <div class="course-block" v-if="studioDetail.content">
            <div class="info-title">课程详情</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.content"></div>
            </div>
          </div>
          <div class="course-block" v-if="studioDetail.final">
            <div class="info-title">最终作品</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.final"></div>
            </div>
          </div>
        </div>
        <!-- 报名须知 -->
        <div class="course-info-main sign-container" ref="signInfo" id="signInfo" v-if="studioDetail && studioDetail.audience">
          <div class="course-block" v-if="studioDetail.audience">
            <div class="info-title">参加对象</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.audience"></div>
            </div>
          </div>
          <div class="course-block" v-if="studioDetail.condition">
            <div class="info-title">报名条件</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.condition"></div>
            </div>
          </div>
          <div class="course-block" v-if="studioDetail.schedule">
            <div class="info-title">时间安排</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.schedule"></div>
            </div>
          </div>
          <div class="course-block" v-if="studioDetail.award">
            <div class="info-title">奖励介绍</div>
            <div class="info-content">
              <div class="rich-text" v-html="studioDetail.award"></div>
            </div>
          </div>
        </div>
        <!-- 其他课程 -->
        <div class="about-workshop" ref="aboutCourse">
          <div class="about-title">
            <div class="title">设计室成果</div>
            <div class="reload-about" @click="getAboutCourse"><icon icon-class="reupload"></icon>换一批</div>
          </div>
          <div class="about-list" v-if="aboutCourse.length > 0">
            <router-link :to="{name: 'ArticleDetail', params: {id: item.id}}" class="about-card" v-for="item in aboutCourse" :key="item.id">
              <div class="course-cover lazy-load"><img :src="item.thumb" alt=""></div>
              <div class="course-info">
                <div class="about-course-title">{{item.title}}</div>
              </div>
            </router-link>
          </div>
          <div class="no-about-course" v-else>没有相关课程</div>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="workshop-control" :class="{'iphonex': isIPhoneX}">
        <!-- 去PC端操作 -->
        <div class="control-item">
          <icon icon-class="new-sign"></icon>
          <div class="control-text">请到官网或微信小程序报名</div>
        </div>
        <!-- 分享 -->
        <div class="control-item share" @click="share">
          <icon icon-class="new-share"></icon>
          <div class="control-text">分享</div>
        </div>
      </div>
      <share :src="locationHref" :title="studioData.title" type="设计室" ref="shareComponent"></share>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .studio-wrapper{
    width: 100%;
    position: relative;
    padding-bottom: 48px;
    &.iphonex{
      padding-bottom: 67px;
    }
    .studio-baseinfo{
      padding: 20px 29px 0 16px;
      .title{
        font-size: 22px;
        line-height: 22px;
        font-weight: bold;
        color: #333;
      }
      .studio-number{
        margin-top: 32px;
        color: #666;
        font-size: 14px;
        line-height: 14px;
        display: inline-block;
        font-weight: bold;
        svg{
          margin-right: 6px;
          font-size: 12px;
          color: @cano;
        }
        .number{
          color: @cano;
        }
      }
      .info-block .info-item{
        display: flex;
        align-items: center;
        margin-top: 16px;
        font-size: 14px;
        line-height: 14px;
        .type{
          width: 96px;
          color: #333;
          font-weight: bold;
        }
        .content{
          color: #666;
          &.error{
            color: #F85C5C;
          }
        }
      }
    }
    .studio-cover{
      .studio-video-title{
        margin-top: 16px;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        color: #333;
        padding-left: 16px;
        font-weight: bold;
        img{
          width: 14px;
          margin-left: 8px;
        }
      }
      .studio-video-box{
        margin-top: 16px;
        width: 100%;
        height: 2rem;
        background: #EEE;
        overflow: hidden;
        img{
          width: 100%;
          transform: translateY(-16%);
        }
      }
      &.status-bar{
        padding-bottom: 34px;
      }
      .cover-info{
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 34px;
        background: @cano;
        color: #FFF;
        padding: 0 16px;
        font-size: 14px;
        &.soon{
          background: #F85C5C;
        }
        .cover-tips{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          svg{
            margin-right: 6px;
            font-size: 12px;
          }
        }
      }
    }
    .course-main-wrapper{
      padding-top: 20px;
      .tab-wrapper{
        height: 34px;
        .course-tab{
          box-sizing: border-box;
          padding: 0 16px;
          background: #FFF;
          border-bottom: 1px solid #EEEEEE;
          height: 34px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &.fixed{
            position: fixed;
            top: 87px;
            left: 0;
            width: 100%;
            z-index: 99;
          }
          .tab-item{
            position: relative;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
            color: #999;
            margin-right: 16px;
            &.active{
              color: #333;
              font-weight: bold;
              &::after{
                content: '';
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 24px;
                height: 3px;
                border-radius: 2px;
                background: @cano;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .course-info-main{
        padding: 0 24px;
        &.sign-container{
          border-top: 8px solid #F3F3F3;
          min-height: 100vh;
        }
        .course-block{
          padding: 20px 0;
          border-bottom: 1px solid #F6F7F8;
          color: #666666;
          &:last-child{
            border-bottom: 0;
          }
          .sub-info{
            font-size: 14px;
            line-height: 14px;
            color: #666;
            margin-bottom: 16px;
            &:last-child{
              margin-bottom: 0;
            }
          }
          .info-title{
            font-size: 16px;
            line-height: 16px;
            color: #333;
            font-weight: bold;
          }
          .info-content{
            margin-top: 16px;
            font-size: 14px;
            line-height: 21px;
            color: #666;
            &.preface{
              margin-top: 0;
            }
            .major-info{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              font-size: 14px;
              color: #666;
              margin-bottom: 6px;
              word-break: break-all;
              max-width: 100%;
              span{
                width: 72px;
                min-width: 72px;
                color: #333;
                white-space: nowrap;
              }
            }
            .course-teacher{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 16px;
              &:last-child{
                margin-bottom: 0;
              }
              .teacher-avatar{
                width: 64px;
                height: 64px;
                min-width: 64px;
                overflow: hidden;
                border-radius: 50%;
                box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              .teacher-info{
                padding-left: 16px;
                font-size: 14px;
                color: #333;
                .teacher-name{
                  line-height: 14px;
                }
                .teacher-title-box{
                  margin-top: 8px;
                  color: #999;
                  font-size: 12px;
                  line-height: 12px;
                  .teacher-title{
                    max-width: 2.6rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    &:first-child{
                      margin-bottom: 6px;
                    }
                  }
                }
              }
            }
          }
          .studio-link{
            position: relative;
            margin-top: 28px;
            box-sizing: border-box;
            height: .55rem;
            background: linear-gradient(270deg,rgba(98,54,255,1) 0%,rgba(134,72,239,1) 100%);
            box-shadow: 0px 8px 16px 0px rgba(134,72,239,0.3);
            border-radius: 4px;
            padding: 0 .16rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #FFF;
            transition: all .2s;
            .link-title{
              font-size: 15px;
              line-height: 15px;
              font-weight: bold;
            }
            .check-link{
              margin-top: 6px;
              font-size: 12px;
              line-height: 12px;
              color: rgba(255, 255, 255, .7);
              svg{
                font-size: 12px;
              }
            }
            .awards-icon{
              position: absolute;
              top: -5px;
              right: 20px;
              width: .62rem;
              .awards{
                width: 100%;
              }
            }
          }
        }
      }
      .about-workshop{
        border-top: 10px solid #F3F3F3;
        padding: 24px;
        .about-title{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title{
            font-size: 18px;
            line-height: 18px;
            color: #333;
            font-weight: 600;
          }
          .reload-about{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: @cano;
            cursor: pointer;
            font-size: 14px;
            line-height: 14px;
            svg{
              font-size: 14px;
              margin-right: 4px;
            }
          }
        }
        .about-list{
          margin-top: 16px;
          .about-card{
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            height: .8rem;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            border-radius: 6px;
            overflow: hidden;
            .course-cover{
              flex-shrink: 0;
              width: .97rem;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                height: 100%;
              }
            }
            .course-info{
              padding: .16rem 0 0 12px;
              flex: 1;
              min-width: 0;
              .about-course-title{
                font-size: 15px;
                line-height: 22px;
                color: #333;
                font-weight: 500;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 2rem;
              }
            }
          }
        }
      }
    }
    /* 小组课底部操作 */
    .workshop-control{
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      height: 48px;
      border-top: 1px solid #BDBDBD;
      background-color: #fff;
      z-index: 990;
      &.iphonex{
        height: 67px;
      }
      .control-item{
        position: relative;
        box-sizing: border-box;
        // flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        background-color: transparent;
        border: 0;
        color: #333;
        padding: 0 36px;
        &::after{
          content: '';
          position: absolute;
          top: 50%;
          right: 0;
          width: 1px;
          height: 18px;
          background: #F6F7F8;
          transform: translateY(-50%);
        }
        &:first-child{
          color: @cano;
        }
        &:last-child::after{
          background-color: transparent;
        }
        .control-text{
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
  }
</style>

<script>
  import Utils from '@/untils/utils'
  import VideoPlayer from '@/components/Common/videoPlayer.vue'
  import share from '@/components/Common/share.vue'
  export default {
    data() {
      return {
        id: null,
        // 是否为iPhoneX
        isIPhoneX: false,
        dataDone: false,
        // 设计室基础信息
        studioData: {},
        // 设计室课程内容
        studioDetail: {},
        // 是否报名截止
        isStop: false,
        // 当前tab
        activeTab: 'info',
        // tab顶部偏移值
        tabOffset: 0,
        tabFixed: false,
        // 报名须知顶部偏移
        signOffset: 0,
        // 相关课程
        aboutCourse: [],
        // 相关课程当前页数
        currentAbout: 0,
        locationHref: '',
      }
    },
    created() {
      this.id = this.$route.params.id;
      this.$store.commit('setActiveMenu', 'course');
      this.locationHref = window.location.href;
      this.getStudioInfo();
    },
    computed: {
      // 是否为特殊设计室
      isSpecialStudio() {
        const idList = [129, 132];
        return idList.includes(parseInt(this.id));
      }
    },
    components: {
      VideoPlayer,
      share
    },
    watch: {
      '$route'() {
        // 跳转其他课程详情时重新获取数据
        this.id = this.$route.params.id;
        this.locationHref = window.location.href;
        this.getStudioInfo();
        $(document).scrollTop(0);
      }
    },
    methods: {
      // 获取切换tab的顶部偏移值
      getTabOffset() {
        this.tabOffset = this.$refs.courseTab.offsetTop;
      },
      // 获取&刷新每个内容区块的高度偏移值
      refreshOffset() {
        if(this.studioDetail.content) this.signOffset = this.$refs.signInfo.offsetTop - 48;
        this.aboutOffset = this.$refs.aboutCourse.offsetTop;
        console.log(this.signOffset)
      },
      tab(type) {
        // this.activeTab = type;
        switch(type) {
          case 'info': {
            $("html,body").animate({scrollTop: this.tabOffset}, 500, () => {this.activeTab = type;});
          };break;
          case 'sign': {
            $("html,body").animate({scrollTop: this.signOffset}, 500, () => {this.activeTab = type;});
          };break;
          case 'other': {
            $("html,body").animate({scrollTop: this.aboutOffset}, 500, () => {this.activeTab = type;});
          }
        }
      },
      getStudioInfo() {
        this.$root.post('/Course/get_studio_info', {
          id: this.$route.params.id
        }).then(data => {
          this.dataDone = true;
          console.log(data);
          // 凯诺币去小数
          data.knb = parseInt(data.knb);
          // 格式化开课时间 / 截止报名时间
          let startTimeStamp = data.firsttime * 1000;
          let enrollTimeStamp = data.enroll_end * 1000;
          // 开课时间
          data.localStartTime = `${Utils.formatTimeToDay(new Date(startTimeStamp))} ${Utils.formatTimeToMoinute(new Date(startTimeStamp))}`
          // 报名截止时间
          data.courseStopApplyTime = `${Utils.formatTimeToDay(new Date(enrollTimeStamp))} ${Utils.formatTimeToMoinute(new Date(enrollTimeStamp))}`
          // 报名截止前一天
          data.stopSoon = (enrollTimeStamp - new Date().getTime()) <= 86400000 ? true : false;
          data.video = data.video ? parseInt(data.video) : null;
          this.studioData = data;
          this.isStop = data.enroll_end > data.now_time ? false : true;
          this.$nextTick(() => {
            // 获取基本信息后初始化百度分享设置
            window._bd_share_config = {
              common: {
                bdText: `《${this.studioData.title}》 - 凯诺设计课 Canopy Institute of Design`, //分享的内容
                bdUrl: window.location.href, //分享的url
                bdPic: document.domain + this.studioData.thumb, //分享的图片
                bdSign: 'off' //禁用回流
              },
              share : [{
                bdCustomStyle: ' '  //此处参数需要传入一个空格，不然会有默认的样式
              }]
            }
            let shareScript = document.createElement('script');
            shareScript.src = '/Application/Home/Resource/vendor/bdShare/static/api/js/share.js?cdnversion='+~(-new Date()/36e5);
            document.getElementsByTagName('body')[0].appendChild(shareScript);

            // 获取tab偏移值&刷新每个内容区块的高度偏移值
            this.getTabOffset();
            $(document).scroll(() => {
              let scrollTop = $(document).scrollTop()
              this.tabFixed = (scrollTop >= this.tabOffset) ? true : false;
              if(scrollTop >= this.signOffset && this.signOffset != 0) {
                this.activeTab = 'sign';
              }else if(scrollTop >= this.aboutOffset && this.aboutOffset != 0) {
                this.activeTab = 'other';
              }else {
                this.activeTab = 'info';
              }
            })
          })
          this.$root.post('/Course/get_studio_detail', {
            id: this.$route.params.id
          }).then(data => {
            data.content = data.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            data.final = data.final.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            data.audience = data.audience.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            data.condition = data.condition.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            data.schedule = data.schedule.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            data.award = data.award.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
            this.studioDetail = data;
            this.$nextTick(() => {
              this.refreshOffset();
              $('.rich-text img').on('load', () => {
                this.refreshOffset();
              })
            })

            setTimeout(() => {
              this.refreshOffset();
            }, 800);
          })
          this.getAboutCourse();
        })
      },
      getAboutCourse() {
        // 获取相关课程内容
        this.$root.post('/Course/get_correlation_article', {
          id: this.$route.params.id,
          page: this.currentAbout,
        }).then(list => {
          if (list.info) {
            this.aboutCourse = list.info;
            // 判断相关课程数量决定是否归1 / 更新当前相关课程页数
            this.currentAbout = parseInt(list.page) == 0 ? 1 : this.currentAbout + 1;
            this.$nextTick(() => {
              this.refreshOffset();
            })
          }
        })
      },
      checkTeacher(item) {
        console.log(item)
        if(item.is_trained == 1) {
          this.$router.push({name: 'LecturerDetail', params: {id: item.uid}})
        }
      },
      share() {
        this.$refs.shareComponent.showMenu();
      },
      toStudioAwards(id) {
        this.$router.push({name: 'ArticleDetail', params: {id: id}});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CourseDetail/studio.vue